"use strict";
/*
 * Created on 03 05 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../core/utils/index");

var SelloutEndReason_1 = require("../model/SelloutEndReason");

var SelloutEndReasonConverter_1 = require("./SelloutEndReasonConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutEndReasonConverterImpl =
/*#__PURE__*/
function (_SelloutEndReasonConv) {
  _inherits(SelloutEndReasonConverterImpl, _SelloutEndReasonConv);

  function SelloutEndReasonConverterImpl() {
    _classCallCheck(this, SelloutEndReasonConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutEndReasonConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutEndReasonConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        description: source.description
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutEndReason_1.SelloutEndReason(conversions.documentToClassId(source), index_1.Utils.asNumber(source.externalId), index_1.Utils.asString(source.description));
    }
  }]);

  return SelloutEndReasonConverterImpl;
}(SelloutEndReasonConverter_1.SelloutEndReasonConverter);

exports.SelloutEndReasonConverterImpl = SelloutEndReasonConverterImpl;